import { createGlobalStyle } from 'styled-components';

import { SIDE_NAV_PROPERTY, SIDE_NAV_WIDTH } from 'common/hooks/useSideNavExpanded';

export default createGlobalStyle`
body {
  margin: 0;
  color-scheme: light;
  ${SIDE_NAV_PROPERTY}: ${SIDE_NAV_WIDTH.Expanded};
}
`;
